import { ENTITY_ACTION_PERMISSIONS_QUERY } from "@app/shared-core/queries/entity-action-permissions.query";
import { LOCATION_DROPDOWN_QUERY } from "@app/shared/company-hierarchy/locations/queries/location-dropdown.query";
import { COMPANY_DROPDOWN_QUERY } from "@app/shared/crm/company/quries/company-dropdown.query";
import { CUSTOMER_DROPDOWN_QUERY } from "@app/shared/crm/customers/queries/customer-dropdown.query";
import { GROUP_ECONOMIC_CONDITIONS_QUERY } from "@app/shared/fleet/group/queries/group-economic-conditions.query";
import { PRICE_LIST_DROPDOWN_QUERY } from "@app/shared/revenue-management/price-lists/queries/price-list-dropdown.query";
import { RESERVATION_SOURCE_PARENT_DROPDOWN_QUERY } from "@app/shared/revenue-management/reservation-source-parents/queries/reservation-source-parent-dropdown.query";
import { RESERVATION_SOURCE_TYPE_DROPDOWN_QUERY } from "@app/shared/revenue-management/reservation-source-types/queries/reservation-source-type-dropdown.query";
import { EMPLOYEE_DROPDOWN_QUERY } from "@app/shared/users/employees/queries/employee-dropdown.query";
import { CREATED_BY_QUERY } from "@app/shared/users/users/queries/created-by.query";
import { RESERVATION_SOURCE_DROPDOWN_QUERY } from "./reservation-source-dropdown.query";

/** GraphQL selection for the reservation source form and edit page: the three Round 2 steps with their references. */
export const RESERVATION_SOURCE_FORM_QUERY = `
  id
  entityId
  enabled
  mainInfo {
    name
    description
    virtualRs
    reservationSourceChannel
    reservationSourceType { ${RESERVATION_SOURCE_TYPE_DROPDOWN_QUERY} }
    reservationSourceParent { ${RESERVATION_SOURCE_PARENT_DROPDOWN_QUERY} }
    customerType
    customers { ${CUSTOMER_DROPDOWN_QUERY} }
    companies { ${COMPANY_DROPDOWN_QUERY} }
    companyCode
    webAccessCode
    internalNote
    referenceSalesperson { ${EMPLOYEE_DROPDOWN_QUERY} }
    commission
    convention { startDate endDate validityReference }
    attachments
  }
  rentalQuotation {
    priceDefinitionMode
    masterReservationSource { ${RESERVATION_SOURCE_DROPDOWN_QUERY} }
    enableProportionalCalculationAcrossSeasons
    priceLists {
      dailyPriceList { ${PRICE_LIST_DROPDOWN_QUERY} }
      monthlyPriceList { ${PRICE_LIST_DROPDOWN_QUERY} }
      bookingWindow { startDate endDate }
      validityWindow { startDate endDate }
      locations { ${LOCATION_DROPDOWN_QUERY} }
      note
    }
  }
  economicConditions {
    id
    groups {
      id
      group { ${GROUP_ECONOMIC_CONDITIONS_QUERY} }
      theftResponsibility
      damageResponsibility
      deposit
    }
  }
  createdBy { ${CREATED_BY_QUERY} }
  createdAt
  updatedAt
  ${ENTITY_ACTION_PERMISSIONS_QUERY}
`;
